export function formatPlainText(text: string) {
  return text
    .replace(/\n/g, '')
    .replace(/<br\s*\/?>/g, '')
    .replace(/<wbr\s*\/?>/g, '')
}

export function formatText(text: string) {
  return text
    .replace(/\n/g, '')
    .replace(/<br\s*\/?>/g, '<br />')
    .replace(/<wbr\s*\/?>/g, '<wbr />')
}

export function formatTextMobile(text: string) {
  return text
    .replace(/\n/g, '')
    .replace(/<br\s*\/?>/g, '<br class="hidden md:block" />')
    .replace(/<wbr\s*\/?>/g, '<wbr />')
}

export function formatDate(date: string) {
  return date.replaceAll('-', '.')
}

export async function sendEmail(
  e: React.FormEvent<HTMLFormElement>,
): Promise<{ success: boolean; error?: string }> {
  try {
    const form = new FormData(e.currentTarget)

    const inquiryType = form.get('inquiryType')?.toString() || ''
    let category
    switch (inquiryType) {
      case 'tax-return':
        category = '暗号資産の税務顧問'
        break
      case 'tax-advisor':
        category = '企業向けの税務顧問'
        break
      case 'other':
        category = 'その他'
        break
    }

    const name = form.get('name')?.toString() || ''
    const company = form.get('company')?.toString() || ''
    const email = form.get('email')?.toString() || ''
    const tel = form.get('tel')?.toString() || ''
    const message = form.get('message')?.toString() || ''

    const res = await fetch('/api/resend', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ category, name, company, email, tel, message }),
    })

    const data = await res.json()

    if (data.status === 'ok') {
      return { success: true }
    } else {
      return { success: false, error: data.message || '送信に失敗しました' }
    }
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : '送信に失敗しました',
    }
  }
}
